import React, { useContext } from 'react';
import { useDrag } from 'react-dnd';
import { ContextMenuContext } from '../DesktopViewPanel'; // Note: Adjust this import path if needed
import { SelectionHighlight } from './styles/PreviewWrapper.styles';

// --- A Generic Wrapper for All Preview Components ---//
const PreviewWrapper = ({
  control, children, renderMode = 'preview', isSelected,
  dragType = 'CONTROL', isDraggable: isDraggableProp = true,
  onSendToBack, index, sectionId, setDropIndicator,
  onClick,
  setSelectedControlId, onHideTooltip
}) => {

  const { showMenu } = useContext(ContextMenuContext);

  const handleContextMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (onHideTooltip) {
      onHideTooltip();
    }

    if (setSelectedControlId) {
      setSelectedControlId(control.id);
    }
    const menuOptions = [
      { label: 'Send to back', action: onSendToBack }
    ];
    showMenu(event.pageX, event.pageY, menuOptions);
  };

  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: dragType,
    item: { ...control, index, sectionId },
    canDrag: isDraggableProp && control.isDraggable,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
    end: (item, monitor) => {
      if (setDropIndicator) {
        setDropIndicator(null);
      }
    },
  }));

  // --- Style Calculation --- //
  const baseStyles = {
    cursor: control.isDraggable ? 'grab' : 'not-allowed',
    opacity: 1,
    display: 'block',
    zIndex: control.zOrder,
  };

  if (renderMode === 'preview') {
    if (control.isPlaced && !isSelected) {
      baseStyles.display = 'none'; // Hide if placed but not selected
    } else if (control.isPlaced && isSelected) {
      baseStyles.opacity = 0.4; // "Ghost" it if placed and selected
    }
  }

  if (isDragging) {
    baseStyles.opacity = 0.5; // Dragging opacity overrides other settings
  }

  const layoutStyles = renderMode === 'preview'
    ? { // For the desktop panel
      position: 'absolute',
      top: `${control.top}px`,
      left: `${control.left}px`,
      width: control.width,
      height: control.height,
    }
    : // For the mobile canvas
    (() => {
      // Special cases for controls that need a fixed height
      if (control.factoryKey === 'control_websignature' || control.factoryKey === 'control_table' || control.factoryKey.includes('separator')) {
        return {
          position: 'relative',
          width: '100%',
          height: control.height
        };
      }
      // Default for all other controls on the canvas
      return {
        position: 'relative',
        width: '100%',
        height: 'auto',
      };
    })();

  return (
    <div
      ref={dragRef}
      style={{ ...baseStyles, ...layoutStyles }}
      title={control.unsupportedMessage || ''}
      onClick={(e) => {
        if (onClick) {
          onClick(e, control);
        }
      }}
      onContextMenu={handleContextMenu}
      className={control.isDraggable ? 'draggable-control' : ''}
    >
      {renderMode === 'preview' && <SelectionHighlight isSelected={isSelected} />}
      {children}
    </div>
  );
};

export default PreviewWrapper;